<template>
    <div style="height: 100%">
        <div name="tishi" class="hint block" style="margin-top: 0">
            <p class="font-red">注意：1.单品式管理的资产入库数量大于1的时候，资产编号不能自动生成，保存的时候以后台系统生成为主；2.设备部件单条最多支持导入10个，每个名称长度不能超过30个字符，部件之间用"|"竖线分割</p>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" class="mb10" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div name="result_table" class="table-layout" v-if="showTable">
            <el-table class="thin" :data="shopDeviceImpItemList" :height="tableHeight" ref="deviceImpInfoTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange"
                      :row-class-name="markSelectedRowClassName">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="execState" label="检查状态" width="60" align="center" fixed="left">
                    <template slot-scope="rows">
                        <span v-if="rows.row.checkState == -1" style="color: red">{{ checkStateMap[rows.row.checkState] }}</span>
                        <span v-else-if="rows.row.checkState == 1" style="color: green">{{ checkStateMap[rows.row.checkState] }}</span>
                        <span v-else>{{ checkStateMap[rows.row.checkState] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="checkFailMsg" label="检查结果信息" width="200" align="left" fixed="left"></el-table-column>
                <el-table-column prop="execState" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <span v-if="rows.row.execState == -1" style="color: red">{{ execStateMap[rows.row.execState] }}</span>
                        <span v-else-if="rows.row.execState == 1" style="color: green">{{ execStateMap[rows.row.execState] }}</span>
                        <span v-else>{{ execStateMap[rows.row.execState] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="execFailMsg" label="执行结果信息" width="200" align="left" fixed="left"></el-table-column>
                <el-table-column prop="warnMsg" label="提示" width="200" align="left" fixed="left" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="viewFieldFlag('batchNo')" :label="getFieldTitle('batchNo')">
                    <el-table-column prop="batchNo" width="120" :render-header="autoSetBatchNo">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.batchNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.batchNo"
                                   :title="rows.row.validateInfo.batchNo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.batchNo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('devcDefNo')" label="关联定义">
                    <el-table-column prop="devcDefId" width="200" :render-header="setBathDevcDef">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.devcDefId.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.devcDefId.errorMsg">
                                <div class="inline-block" v-if="rows.row.devcDefId != null && rows.row.devcDefId != -1">已关联</div>
                                <div class="inline-block" v-else>未关联</div>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.devcDefId == null || rows.row.devcDefId == -1" @click="setDevcDef(rows.row)">选择</a>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.devcDefId != null && rows.row.devcDefId != -1" @click="showDevcDef(rows.row.devcDefId)">查看</a>
                            </div>
                            <div v-else>
                                <div class="inline-block" v-if="rows.row.devcDefId != null">已关联</div>
                                <div class="inline-block" v-else>未关联</div>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.devcDefId == null || rows.row.devcDefId == -1" @click="setDevcDef(rows.row)">选择</a>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.devcDefId != null && rows.row.devcDefId != -1" @click="showDevcDef(rows.row.devcDefId)">查看</a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('devcDefNo')" :label="getFieldTitle('devcDefNo')" align="center">
                    <el-table-column prop="devcDefCode" width="140">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.devcDefId.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.devcDefId.errorMsg">
                                <span v-if="rows.row.devcDefCode != null">{{ rows.row.devcDefCode }}</span>
                            </div>
                            <div v-else>
                                <span v-if="rows.row.devcDefCode != null">{{ rows.row.devcDefCode }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerNo')" :label="getFieldTitle('innerNo')">
                    <el-table-column prop="innerNo" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.innerNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.innerNo"
                                   :title="rows.row.validateInfo.innerNo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.innerNo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('upc')" :label="getFieldTitle('upc')">
                    <el-table-column prop="upc" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.upc.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.upc" :title="rows.row.validateInfo.upc.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.upc"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('title')" :label="getFieldTitle('title')">
                    <el-table-column prop="devcTitle" width="250">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.devcTitle.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.devcTitle"
                                   :title="rows.row.validateInfo.devcTitle.errorMsg"/>
                            <input type="text" v-else style="width:240px" @change="commonChangeEvent" v-model="rows.row.devcTitle"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('name')" :label="getFieldTitle('name')">
                    <el-table-column prop="devcName" width="250">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.devcName.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.devcName"
                                   :title="rows.row.validateInfo.devcName.errorMsg"/>
                            <input type="text" v-else style="width:240px" @change="commonChangeEvent" v-model="rows.row.devcName"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('retailerBizUnitName')" :label="getFieldTitle('retailerBizUnitName')">
                    <el-table-column prop="bizUnitName" width="250">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.bizUnitName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.bizUnitName.errorMsg">
                                <span>{{ rows.row.bizUnitName }}&nbsp;</span>
                            </div>
                            <span v-else>{{ rows.row.bizUnitName }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('retailerComName')" :label="getFieldTitle('retailerComName')">
                    <el-table-column prop="shopName" width="250">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.shopName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.shopName.errorMsg">
                                <span>{{ rows.row.shopName }}&nbsp;</span>
                            </div>
                            <span v-else>{{ rows.row.shopName }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('initStartDate')" :label="getFieldTitle('initStartDate')" align="center">
                    <el-table-column prop="initStartDate" width="90" align="center" :render-header="setInitStartDate">
                        <template slot-scope="rows">
                            <div v-if="rows.row.assetType != '批量式管理'">
                                <div v-if="!rows.row.validateInfo.initStartDate.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.initStartDate.errorMsg">
                                    <span>{{ rows.row.initStartDate || '' }}</span>
                                </div>
                                <span v-else>{{ rows.row.initStartDate || '' }}</span>
                            </div>
                            <div v-else>
                                <span>{{ rows.row.initStartDate }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerDevcCatCode')" :label="tplUsage == 'devc.import' ? '设备分类' : '资产分类'">
                    <el-table-column prop="innerDevcCatName" width="150" :render-header="setDevcCat">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcCatName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcCatName.errorMsg">
                                <span>{{ rows.row.innerDevcCatName }}&nbsp;</span>
                            </div>
                            <div v-else>{{ rows.row.innerDevcCatName }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerDevcCatCode')" :label="getFieldTitle('innerDevcCatCode')" align="center">
                    <el-table-column prop="innerDevcCatCode" width="150">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.innerDevcCatCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.innerDevcCatCode"
                                   :title="rows.row.validateInfo.innerDevcCatCode.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.innerDevcCatCode"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerDevcBrandCode')" :label="tplUsage == 'devc.import' ? '设备品牌' : '资产品牌'">
                    <el-table-column prop="innerDevcBrandName" width="150" :render-header="setDevcBrand">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcBrandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcBrandName.errorMsg">
                                <span>{{ rows.row.innerDevcBrandName }}&nbsp;</span>
                            </div>
                            <div v-else>{{ rows.row.innerDevcBrandName }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('innerDevcBrandCode')" :label="getFieldTitle('innerDevcBrandCode')">
                    <el-table-column prop="innerDevcBrandCode" width="150">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.innerDevcBrandCode.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcBrandCode.errorMsg">
                                <span>{{ rows.row.innerDevcBrandCode }}&nbsp;</span>
                            </div>
                            <div v-else>{{ rows.row.innerDevcBrandCode }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('devcGroupFullName')" :label="getFieldTitle('devcGroupFullName')">
                    <el-table-column prop="devcGroupFullName" width="150" :render-header="setDevcGroup">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.devcGroupFullName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.devcGroupFullName.errorMsg">
                                <span>{{ rows.row.devcGroupFullName }}&nbsp;</span>
                            </div>
                            <div v-else>{{ rows.row.devcGroupFullName }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('brandName')" :label="getFieldTitle('brandName')">
                    <el-table-column prop="brandName" width="150" :render-header="setBrand">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.brandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.brandName.errorMsg">
                                <span>{{ rows.row.brandName }}</span>
                            </div>
                            <span v-else>{{ rows.row.brandName }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('model')" :label="getFieldTitle('model')">
                    <el-table-column prop="model" width="220">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.model.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.model"
                                   :title="rows.row.validateInfo.model.errorMsg"/>
                            <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.model"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('fixedSpec')" :label="getFieldTitle('fixedSpec')">
                    <el-table-column prop="fixedSpec" width="220">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.fixedSpec.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.fixedSpec"
                                   :title="rows.row.validateInfo.fixedSpec.errorMsg"/>
                            <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.fixedSpec"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('vendorCreditCode')" :label="getFieldTitle('vendorCreditCode')">
                    <el-table-column prop="innerVendorNo" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.innerVendorNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.innerVendorNo"
                                   :title="rows.row.validateInfo.innerVendorNo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.innerVendorNo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('vendorSn')" :label="getFieldTitle('vendorSn')">
                    <el-table-column prop="vendorSn" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.vendorSn.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.vendorSn"
                                   :title="rows.row.validateInfo.vendorSn.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.vendorSn"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('assetTypeTitle')" :label="getFieldTitle('assetTypeTitle')" width="140" align="center">
                    <el-table-column prop="assetType" width="140" align="center">
                        <template slot-scope="rows">
                            <el-select v-model="rows.row.assetType">
                                <el-option v-for="item in assetTypeList" :label="item.text" :value="item.value"/>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('inspectFlag')" :label="getFieldTitle('inspectFlag')" align="center">
                    <el-table-column prop="inspectFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.inspectFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('patrolFlag')" :label="getFieldTitle('patrolFlag')" align="center">
                    <el-table-column prop="patrolFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.patrolFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('maintFlag')" :label="getFieldTitle('maintFlag')" align="center">
                    <el-table-column prop="maintFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.maintFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('repairFlag')" :label="getFieldTitle('repairFlag')" align="center">
                    <el-table-column prop="repairFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.repairFlag" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('splitible')" :label="getFieldTitle('splitible')" align="center">
                    <el-table-column prop="splitible" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.splitible" @change="commonChangeEvent"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('existQuanity')" :label="getFieldTitle('existQuanity')" align="center">
                    <el-table-column prop="quantity" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.quantity.validateOk" @change="commonChangeEvent(rows.row, 'quantity')" type="number" style="background-color: #edd28b; width: 90px" size="6"
                                   v-model="rows.row.quantity" :min="0" :max="100000" :title="rows.row.validateInfo.quantity.errorMsg"/>
                            <input class="align-right" v-else type="number" size="6" @change="commonChangeEvent(rows.row, 'quantity')" v-model="rows.row.quantity" :min="0" :max="100000" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('theUnit')" :label="getFieldTitle('theUnit')">
                    <el-table-column prop="theUnit" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.theUnit.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.theUnit"
                                   :title="rows.row.validateInfo.theUnit.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.theUnit"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('expectedLife')" :label="getFieldTitle('expectedLife')" align="center">
                    <el-table-column prop="expectedLife" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.expectedLife.validateOk" @change="commonChangeEvent(rows.row, 'expectedLife')" type="number" style="background-color: #edd28b; width: 90px" size="6"
                                   v-model="rows.row.expectedLife" :min="0" :max="100000" :title="rows.row.validateInfo.quantity.errorMsg"/>
                            <input class="align-right" v-else type="number" size="6" @change="commonChangeEvent(rows.row, 'expectedLife')" v-model="rows.row.expectedLife" :min="0" :max="100000" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('receiveTime')" :label="getFieldTitle('receiveTime')" align="center">
                    <el-table-column prop="recvDate" width="90" align="center" :render-header="setRecvDate">
                        <template slot-scope="rows">
                            <div v-if="rows.row.buyDate == null && rows.row.recvDate == null" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.recvDate.errorMsg">
                                <span>&nbsp;</span>
                            </div>
                            <div v-else>
                                <div v-if="!rows.row.validateInfo.recvDate.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.recvDate.errorMsg">
                                    <span>{{ rows.row.recvDate }}</span>
                                </div>
                                <span v-else>{{ rows.row.recvDate }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('receiptDate')" :label="getFieldTitle('receiptDate')" align="center">
                    <el-table-column prop="receiptDate" width="90" align="center" :render-header="setReceiptDate">
                        <template slot-scope="rows">
                            <div v-if="rows.row.receiptDate == null && rows.row.receiptDate == null" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.receiptDate.errorMsg">
                                <span>&nbsp;</span>
                            </div>
                            <div v-else>
                                <div v-if="!rows.row.validateInfo.receiptDate.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.receiptDate.errorMsg">
                                    <span>{{ rows.row.receiptDate }}</span>
                                </div>
                                <span v-else>{{ rows.row.receiptDate }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('wrntPeriod')" :label="getFieldTitle('wrntPeriod')" align="center">
                    <el-table-column prop="wrntPeriod" width="100" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" v-if="!rows.row.validateInfo.wrntPeriod.validateOk" @change="commonChangeEvent" type="number" style="background-color: #edd28b; width: 90px" size="4" v-model="rows.row.wrntPeriod"
                                   :min="0" :max="100000" :title="rows.row.validateInfo.wrntPeriod.errorMsg"/>
                            <input class="align-right" v-else type="number" size="4" @change="commonChangeEvent" v-model="rows.row.wrntPeriod" :min="0" :max="100000" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('respblDepartName')" :label="getFieldTitle('respblDepartName')">
                    <el-table-column prop="departName" width="120" :render-header="setDepart">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.departName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.departName.errorMsg">
                                <span>{{ rows.row.departName }}</span>
                            </div>
                            <div v-else>{{ rows.row.departName }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('departNo')" :label="getFieldTitle('departNo')">
                    <el-table-column prop="departNo" width="120">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.departName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.departName.errorMsg">
                                <span>{{ rows.row.departNo }}</span>
                            </div>
                            <div v-else>{{ rows.row.departNo }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('respblStaffName')" :label="getFieldTitle('respblStaffName')">
                    <el-table-column prop="principalName" width="200" :render-header="setBathPrincipal">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.principalName.validateOk" class="inline-block" style="background-color: #edd28b; width: 50%;height: 100%" :title="rows.row.validateInfo.principalName.errorMsg">
                                <span>{{ rows.row.principalName }}</span>
                            </div>
                            <div class="inline-block" v-else>{{ rows.row.principalName }}</div>
                            <a class="swb-btn-link fr inline-block" @click="delPrincipal(rows.row)">清除</a>
                            <a class="swb-btn-link fr inline-block" @click="setPrincipal(rows.row)">设置</a>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('principalNo')" :label="getFieldTitle('principalNo')">
                    <el-table-column prop="principalNo" width="200">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.principalName.validateOk" class="inline-block" style="background-color: #edd28b; width: 50%;height: 100%" :title="rows.row.validateInfo.principalName.errorMsg">
                                <span>{{ rows.row.principalNo }}</span>
                            </div>
                            <div class="inline-block" v-else>{{ rows.row.principalNo }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('useMannerText')" :label="getFieldTitle('useMannerText')" width="140" align="center">
                    <el-table-column prop="useManner" width="140" align="center">
                        <template slot-scope="rows">
                            <el-select v-model="rows.row.useManner" @change="commonChangeEvent">
                                <el-option v-for="item in devcUseMannerList" :key="item.value" :label="item.text" :value="item.value"/>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('devcParts')" :label="getFieldTitle('devcParts')">
                    <el-table-column prop="devcParts" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.devcParts.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 95%" v-model="rows.row.devcParts"
                                   :title="rows.row.validateInfo.devcParts.errorMsg"/>
                            <input type="text" style="width: 95%" @change="commonChangeEvent" v-model="rows.row.devcParts" v-else/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('memo')" :label="getFieldTitle('memo')">
                    <el-table-column prop="memo" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo" :title="rows.row.validateInfo.memo.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('memo1')" :label="getFieldTitle('memo1')">
                    <el-table-column prop="memo1" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo1.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo1"
                                   :title="rows.row.validateInfo.memo1.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo1"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('memo2')" :label="getFieldTitle('memo2')">
                    <el-table-column prop="memo2" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo2.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo2"
                                   :title="rows.row.validateInfo.memo2.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo2"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('memo3')" :label="getFieldTitle('memo3')">
                    <el-table-column prop="memo3" width="120">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.memo3.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.memo3"
                                   :title="rows.row.validateInfo.memo3.errorMsg"/>
                            <input type="text" v-else style="width:110px" @change="commonChangeEvent" v-model="rows.row.memo3"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="viewFieldFlag('classifyTagName')" :label="getFieldTitle('classifyTagName')">
                    <el-table-column prop="classifyTagName" width="120" :render-header="setClassifyTag">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.classifyTagName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.classifyTagName.errorMsg">
                                <span>{{ rows.row.classifyTagName }}&nbsp;</span>
                            </div>
                            <div v-else>{{ rows.row.classifyTagName }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <template v-for="field in devcCustFieldList">
                    <el-table-column v-if="viewFieldFlag('ext-' + field.name, true)" :label="'自定义-' + field.title">
                        <el-table-column width="120" v-if="field.type == 'Date'" :render-header="((event)=>{return setCustField(event, 'ext-' + field.name)})">
                            <template slot-scope="rows">
                                <div v-if="rows.row.assetType != '批量式管理'">
                                    <span v-if="rows.row.custFiled['ext-' + field.name] != null">{{ rows.row.custFiled['ext-' + field.name] }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="120" v-else>
                            <template slot-scope="rows">
                                <div v-if="rows.row.assetType != '批量式管理' && rows.row.classifyTagId != null && classifyTagMap[rows.row.classifyTagId].fieldIds.indexOf(field.id) > -1">
                                    <div v-if="field.type == 'String'">
                                        <input type="text" style="width:110px" @change="commonChangeEvent" v-model="rows.row.custFiled['ext-' + field.name]"/>
                                    </div>
                                    <div v-else-if="field.type == 'Integer' || field.type == 'Long' || field.type == 'Float' || field.type == 'Double'">
                                        <input class="align-right" type="number" size="4" @change="commonChangeEvent" v-model="rows.row.custFiled['ext-' + field.name]" style="width: 90px"/>
                                    </div>
                                    <div v-else-if="field.type == 'Boolean'">
                                        <input type="checkbox" v-model="rows.row.custFiled['ext-' + field.name]" @change="commonChangeEvent"/>
                                    </div>
                                </div>
                                <div v-else>
                                    <input type="text" style="width:110px" :disabled="true"/>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="clearfix" name="pagination">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <!--<div class="swb-btn swb-btn-small fr mt10" @click="downloadDeviceImpModel">导出</div>-->
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="deviceImpIn">导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="saveImpItemList">保存</div>
        </div>
    </div>

</template>

<script>
import { Utils, $ } from '../../app.base'
import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
import { openPageRouteUrl, getDefaultPageSizes } from '../../../src/app.conf'
import { showMerchtDevcDefSelectDlg, openDevcDefDetailDlg } from '../devcDef/showDlg'
import { showDevcGroupCatSelectDlg, openBrandListSelectDlg, showDevcCatSelectDlg, showDevcBrandSelectDlg, showDevcGroupSelectDlg } from '../categ/selectDlg'
import { openComStaffComnSelectDlg } from '../orgStruct/selectDlg'
import { showDevcClassifyTagListSelectDlg } from '../devcCust/selectDlg'
import { getMerchantBizParam } from '../asset/assetMain'
import { getAssetKindListAll, loadAssetDeprMethodList, loadAllotAcntMethodList } from '../retailer/asset-comn'
import { fileUploadGroupShowDlg } from '../comn/dialog'

import devcApi from '../../api/devc'
import retailerApi from '../../api/retailer'
import shopStockApi from '../../api/shopStock'
import userApi from '../../api/user'
import devcDefApi from '../../api/devcDef'
import merchtComnApi from '../../api/merchtComn'
import comnApi from '../../api/comn'

import SwbCategTree from '../categ/CategTree';

Vue.regist(SwbCategTree);
import SwbDefServicerForSelect from '../servicer/DefServicerForSelect';

Vue.regist(SwbDefServicerForSelect);
import SwbBrandSelect from '../categ/BrandSelect';

Vue.regist(SwbBrandSelect);
import SwbShopDeviceImpSetDate from '../retailer/ShopDeviceImpSetDate';

Vue.regist(SwbShopDeviceImpSetDate);
import SwbDevcCatList from '../categ/DevcCatList';

Vue.regist(SwbDevcCatList);

let searchConfigData = {
    'queryFields': [{
        'code': 'checkState',
        'label': '检查状态',
        'type': 'Select',
        'valueType': 'Integer',
        'basic': true,
        'hidden': false,
        'rptUsed': false,
        'dataList': [{'value': null, 'label': '- 全部 -'}, {'value': '0', 'label': '未核对'}, {'value': '-1', 'label': '核对无效'}]
    }, {
        'code': 'execState',
        'label': '执行状态',
        'type': 'Select',
        'valueType': 'Integer',
        'basic': true,
        'hidden': false,
        'rptUsed': false,
        'dataList': [{'value': null, 'label': '- 全部 -'}, {'value': '0', 'label': '未执行'}, {'value': '-1', 'label': '执行失败'}]
    }],
    'sortFields': []
};

export default {
    name: 'swb-shop-devc-imp-devc-check',
    desc: '机构设备导入检查',
    props: ['recId'],
    data: function () {
        return {
            tableHeight: 0,
            pageNumber: 1,
            totalCount: 0,
            pageSizze: null,
            pageSizes: [15, 50, 100, 200],// 特殊页面处理
            isOk: false,
            theLoading: null,
            multipleSelection: [],
            retailerInfo: null,
            virtualBrandStr: '',
            max_quantity_per_item: 500,

            warehouseList: [],
            startFlag: false, // 标记是否已开始逐条执行
            nextIndex: 0,
            checkNextIndex: 0,
            scopeId: null,
            showBizUnitWarehouse: false,
            acctEnterWayList: getEnumList('acctEnterWay'),
            deviceUseStateList: getEnumList('deviceUseState'),
            assetTypeList: [],
            devcVoucherTypeList: getEnumList('devcVoucherType'),
            devcUseMannerList: [],
            assetDeprMethodList: [],
            allotAcntMethodList: [],
            devcCustFieldList: [],
            devcCustFieldMap: {},
            classifyTagMap: {},
            deviceKindList: [],
            deviceKindMap: {},
            allotAcntMethodMap: {},
            //
            queryConfig: searchConfigData || {},
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {}
            },
            shopDeviceImpRec: {},
            shopDeviceImpItemList: [],
            filterItems: {},
            checkStateMap: getEnumMap('checkState', 'value2text'),
            execStateMap: getEnumMap('execState', 'value2text'),
            refreshFlag: false,
            fieldMap: {},
            custFileds: [],
            showTable: true,
            tplUsage: null
        }
    },
    watch: {},
    created: function () {
        let self = this;
        this.pageSize = this.pageSizes.first();
        this.getDevcCustFieldList();
        this.getDevcClassifyTagPageList();
        // 折旧算法
        loadAssetDeprMethodList(0, function (dataList) {
            self.assetDeprMethodList = Utils.merge([], dataList);
        });
        loadAllotAcntMethodList(function (dataList) {
            self.allotAcntMethodList = Utils.merge([], dataList);
        });
        this.allotAcntMethodMap = getEnumMap('allotAcntMethod', 'value2text');
        //
        let theLoading = MsgBox.loading();
        getAssetKindListAll(function (dataList) {
            self.deviceKindList = dataList;
            let deviceKindMap = dataList.toMap('code');
            delete deviceKindMap[''];
            self.deviceKindMap = deviceKindMap;
        });
        //
        let devcUseMannerList = getEnumList('devcUseManner') || [];
        let useMannerList = [];
        for(let i = 0; i < devcUseMannerList.length; i++) {
            let useManner = devcUseMannerList[i];
            if(useManner.name != 'None') {
                useMannerList.push(useManner);
            }
        }
        this.devcUseMannerList = Utils.merge([], useMannerList);
        // 管理方式
        let assetTypeEnumList = getEnumList('assetType') || [];
        let assetTypeList = [];
        for(let i = 0; i < assetTypeEnumList.length; i++) {
            let assetTypeEnum = assetTypeEnumList[i];
            if(assetTypeEnum.name == 'CommonDevc' || assetTypeEnum.name == 'DurableDevc') {
                assetTypeList.push(assetTypeEnum);
            }
        }
        this.assetTypeList = Utils.merge([], assetTypeList);
        this.getCurrUserInfo();
        this.getShopDeviceImpRecById(this.recId);
        theLoading.close();
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.tableHeight = height - 18;
        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.hint, [name="pagination"], [name="query-sort-block"], [name="tishi"]'));
        domSizeWatcher.start(500);
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        viewFieldFlag(name, ignoreBase) {
            let custFileds = this.custFileds;
            let custFlag = true;
            if(!Utils.isNoB(custFileds) && custFileds.length > 0) {
                custFlag = this.custFileds.indexOf(name) > -1;
            }
            //
            let baseFlag = this.fieldMap[name] != null;
            if(Utils.isTrue(ignoreBase)) {
                baseFlag = true;
            }
            return custFlag && baseFlag;
        },
        getFieldTitle(name, defTitle) {
            return this.fieldMap[name] != null ? this.fieldMap[name].title : defTitle;
        },
        getComnXportConfByUsage(usage) {
            let self = this;
            let theLoading = MsgBox.loading();
            comnApi.getComnXportConfByUsage({usage: usage}, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    let comnXportConf = result.data;
                    //
                    let sheetList = comnXportConf.sheetList;
                    sheetList.forEach(function (sheet) {
                        if(sheet.name == '店铺资产列表') {
                            let fieldList = sheet.fieldList;
                            self.fieldMap = fieldList.toMap('name');
                        }
                    });
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getDevcCustFieldList() {
            let self = this;
            let theLoading = MsgBox.loading();
            merchtComnApi.getDevcCustFieldList({}, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    let devcCustFieldList = result.data;
                    self.devcCustFieldList = devcCustFieldList;
                    self.devcCustFieldMap = devcCustFieldList.toMap('id');
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getDevcClassifyTagPageList() {
            let self = this;
            let theLoading = MsgBox.loading();
            merchtComnApi.getDevcClassifyTagPageList({
                filterItems: {
                    includeFields: true
                },
                pagination: {
                    pageSize: 999999
                }
            }, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    let classifyTagList = result.data.rows || [];
                    classifyTagList.forEach(function (tag) {
                        tag.fieldIds = tag.devcClassifyTagSpecFields.pluck('custFieldId');
                    });
                    self.classifyTagMap = classifyTagList.toMap('id');
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getCurrUserInfo() {
            let self = this;
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == 'info') {
                    self.scopeId = result.data.scopeEntity.scopeId;
                }
            });
        },
        markSelectedRowClassName(row) {
            return this.multipleSelection.find(function (tmpRow) {
                return tmpRow.rowNo == row.rowNo;
            }) != null ? 'selected-row' : '';
        },
        toAssetKindName(code) {
            let kindObj = this.deviceKindMap[code];
            return kindObj == null ? '' : kindObj.name;
        },
        commonChangeEvent(row, colName) {
            if(!Utils.isNoB(colName) && colName == 'quantity') {
                // 单品式管理的资产要判断数量，当数量大于1的时候不能自动生成资产编码
                if(!Utils.isTrue(row.assetType == '批量式管理') && !Utils.isNoB(row.quantity) && row.quantity > 1) {
                    row.innerCode = null;
                }
            } else if(!Utils.isNoB(colName) && colName == 'assetKindCode') {
                row.assetKindName = this.toAssetKindName(row.assetKindCode);
            }
            this.checkData();
        },
        quantityChangeEvent(value) {
            this.checkData();
        },
        getRetailerInfo() {
            let self = this;
            retailerApi.getRetailer({}, function (result) {
                if(result.type == 'info') {
                    self.retailerInfo = result.data;
                } else {
                    self.$message.warning(result.message);
                }
            });
        },
        checkData() {
            let self = this;
            let rows = this.shopDeviceImpItemList.clone();
            let itemLength = rows.length;
            let byItemFlag = itemLength > 500;
            for(let i = 0; i < rows.length; i++) {
                let row = rows[i];
                row.validateInfo = {
                    devcDefId: {validateOk: true},
                    batchNo: {validateOk: true},
                    innerCode: {validateOk: true},
                    innerNo: {validateOk: true},
                    upc: {validateOk: true},
                    devcName: {validateOk: true},
                    devcTitle: {validateOk: true},
                    shopName: {validateOk: true},
                    bizUnitName: {validateOk: true},
                    initStartDate: {validateOk: true},
                    innerDevcCatName: {validateOk: true},
                    innerDevcCatCode: {validateOk: true},
                    innerDevcBrandName: {validateOk: true},
                    innerDevcBrandCode: {validateOk: true},
                    devcGroupFullName: {validateOk: true},
                    brandName: {validateOk: true},
                    model: {validateOk: true},
                    fixedSpec: {validateOk: true},
                    fixedSpecCode: {validateOk: true},
                    innerVendorNo: {validateOk: true},
                    vendorSn: {validateOk: true},
                    sellerInnerCode: {validateOk: true},
                    assetType: {validateOk: true},
                    quantity: {validateOk: true},
                    theUnit: {validateOk: true},
                    buyDate: {validateOk: true},
                    recvDate: {validateOk: true},
                    receiptDate: {validateOk: true},
                    onsetDate: {validateOk: true},
                    wrntPeriod: {validateOk: true},
                    orgWorth: {validateOk: true},
                    durableLife: {validateOk: true},
                    expectedLife: {validateOk: true},
                    aggtDeprWorth: {validateOk: true},
                    departName: {validateOk: true},
                    principalName: {validateOk: true},
                    devcParts: {validateOk: true},
                    memo: {validateOk: true},
                    memo1: {validateOk: true},
                    memo2: {validateOk: true},
                    memo3: {validateOk: true},
                    classifyTagName: {validateOk: true},
                    deprMethodName: {validateOk: true},
                    rmnWorthRatio: {validateOk: true},
                    allotAcntMethod: {validateOk: true},
                    transWorthRatio: {validateOk: true},
                    assetKindCode: {validateOk: true},
                    deprSpecCode: {validateOk: true},
                };
                if(Utils.isNoB(row.devcDefId) || row.devcDefId == -1) {
                    row.validateInfo.devcDefId = {
                        validateOk: false,
                        errorMsg: '[关联定义]单元不能为空'
                    };
                }
                // 检查修正 [批次号]
                if(!Utils.isNoB(row.batchNo)) {
                    row.batchNo = this.replaceSL(row.batchNo, '');
                    if(row.batchNo.length > 20) {
                        row.validateInfo.batchNo = {
                            validateOk: false,
                            errorMsg: '[批次号]单元长度最大20，当前[' + row.batchNo.length + ']'
                        };
                    }
                } else {
                    row.validateInfo.batchNo = {
                        validateOk: false,
                        errorMsg: '[批次号]单元不能为空'
                    };
                }
                // 检查修正 [内部编码]
                if(!Utils.isNoB(row.innerNo)) {
                    row.innerNo = this.replaceSL(row.innerNo, '');
                    if(row.innerNo.length > 30) {
                        row.validateInfo.innerNo = {
                            validateOk: false,
                            errorMsg: '[外部系统编号]单元长度最大30，当前[' + row.innerNo.length + ']'
                        };
                    }
                }
                // 检查修正 [统一商品代码(UPC)]
                if(!Utils.isNoB(row.upc)) {
                    row.upc = this.replaceSL(row.upc, '');
                    if(row.upc.length > 30) {
                        row.validateInfo.upc = {
                            validateOk: false,
                            errorMsg: '[统一商品代码(UPC)]单元长度最大30，当前[' + row.upc.length + ']'
                        };
                    }
                }
                // 检查 [设备名称]
                if(!Utils.isNoB(row.devcName)) {
                    row.devcName = this.replaceSL(row.devcName, ' ');
                }
                if(Utils.isNoB(row.devcName)) {
                    row.validateInfo.devcName = {
                        validateOk: false,
                        errorMsg: '[名称]单元不可为空'
                    };
                } else if(row.devcName.length > 30) {
                    row.validateInfo.devcName = {
                        validateOk: false,
                        errorMsg: '[名称]单元长度最大30，当前[' + row.devcName.length + ']'
                    };
                }
                // 检查[资产描述全称]
                if(!Utils.isNoB(row.devcTitle)) {
                    row.devcTitle = this.replaceSL(row.devcTitle, ' ');
                }
                if(Utils.isNoB(row.devcTitle)) {
                    row.validateInfo.devcTitle = {
                        validateOk: false,
                        errorMsg: '[资产描述全称]单元不可为空'
                    };
                } else if(row.devcTitle.length > 60) {
                    row.validateInfo.devcTitle = {
                        validateOk: false,
                        errorMsg: '[资产描述全称]单元长度最大60，当前[' + row.devcTitle.length + ']'
                    };
                }
                // 资产分类
                if(Utils.isNoB(row.innerDevcCatId)) {
                    if(!Utils.isNoB(row.innerDevcCatName)) {
                        row.validateInfo.innerDevcCatName = {
                            validateOk: false,
                            errorMsg: '[资产分类]不存在,请预设资产分类'
                        };
                    } else {
                        row.validateInfo.innerDevcCatName = {
                            validateOk: false,
                            errorMsg: '[资产分类]不可为空'
                        };
                    }
                    if(!Utils.isNoB(row.innerDevcCatCode)) {
                        row.validateInfo.innerDevcCatCode = {
                            validateOk: false,
                            errorMsg: '[资产分类编码]不存在,请预设资产分类'
                        };
                    } else {
                        row.validateInfo.innerDevcCatCode = {
                            validateOk: false,
                            errorMsg: '[资产分类编码]不可为空'
                        };
                    }
                }
                // 资产品牌
                if(Utils.isNoB(row.innerDevcBrandId)) {
                    if(!Utils.isNoB(row.innerDevcBrandName)) {
                        row.validateInfo.innerDevcBrandName = {
                            validateOk: false,
                            errorMsg: '[资产品牌]不存在,请预设资产品牌'
                        };
                    } else {
                        row.validateInfo.innerDevcBrandName = {
                            validateOk: false,
                            errorMsg: '[资产品牌]不可为空'
                        };
                    }
                    if(!Utils.isNoB(row.innerDevcBrandCode)) {
                        row.validateInfo.innerDevcBrandCode = {
                            validateOk: false,
                            errorMsg: '[资产品牌编码]不存在,请预设资产品牌'
                        };
                    } else {
                        row.validateInfo.innerDevcBrandCode = {
                            validateOk: false,
                            errorMsg: '[资产品牌编码]不可为空'
                        };
                    }
                }
                // 检查 [型号]
                if(!Utils.isNoB(row.model)) {
                    row.model = this.replaceSL(row.model, ' ');
                }
                if(Utils.isNoB(row.model)) {
                    //
                } else if(row.model.length > 30) {
                    row.validateInfo.model = {
                        validateOk: false,
                        errorMsg: '[型号]单元长度最大30，当前[' + row.model.length + ']'
                    };
                }
                // 检查 [规格]
                if(!Utils.isNoB(row.fixedSpec)) {
                    row.fixedSpec = this.replaceSL(row.fixedSpec, ' ');
                }
                if(Utils.isNoB(row.fixedSpec)) {
                    row.validateInfo.fixedSpec = {
                        validateOk: false,
                        errorMsg: '[规格]单元不能为空'
                    };
                } else if(row.fixedSpec.length > 45) {
                    row.validateInfo.fixedSpec = {
                        validateOk: false,
                        errorMsg: '[规格]单元长度最大45，当前[' + row.fixedSpec.length + ']'
                    };
                }
                //
                let modelSpec = row.model + row.fixedSpec;
                if(Utils.isNoB(modelSpec) || modelSpec.length > 75) {
                    row.validateInfo.model = {
                        validateOk: false,
                        errorMsg: '[型号 + 规格]单元长度最大75，当前[' + row.model.length + ']'
                    };
                    row.validateInfo.fixedSpec = {
                        validateOk: false,
                        errorMsg: '[型号 + 规格]单元长度最大75，当前[' + row.fixedSpec.length + ']'
                    };
                }
                // 检查修正 [供商统一社会信用码]
                if(!Utils.isNoB(row.innerVendorNo)) {
                    row.innerVendorNo = this.replaceSL(row.innerVendorNo, '');
                    if(row.innerVendorNo.length != 18) {
                        row.validateInfo.innerVendorNo = {
                            validateOk: false,
                            errorMsg: '[供商统一社会信用码]单元长度必须为18，当前[' + row.innerVendorNo.length + ']'
                        };
                    }
                }
                // 检查修正 [厂商序列号]
                if(row.assetType != '批量式管理') {
                    if(!Utils.isNoB(row.vendorSn)) {
                        row.vendorSn = this.replaceSL(row.vendorSn, '');
                        if(!Utils.isNaturalStr(row.quantity, true) || row.quantity != 1) {
                            row.validateInfo.vendorSn = {
                                validateOk: false,
                                errorMsg: '[厂商序列号]单元有效时数量必须为1'
                            };
                        } else {
                            if(row.vendorSn.length > 30) {
                                row.validateInfo.vendorSn = {
                                    validateOk: false,
                                    errorMsg: '[厂商序列号]单元长度最大30，当前[' + row.vendorSn.length + ']'
                                };
                            }
                        }
                    }
                }
                if(Utils.isNoB(row.assetType)) {
                    row.validateInfo.assetType = {
                        validateOk: false,
                        errorMsg: '[管理方式]单元不可为空'
                    };
                }
                // 检查 [数量]
                if(!Utils.isNaturalStr(row.quantity, true)) {
                    row.validateInfo.quantity = {
                        validateOk: false,
                        errorMsg: '[数量]单元不能为空并且必须为大于0的整数'
                    };
                }
                // 检查 [单位]
                if(!Utils.isNoB(row.theUnit)) {
                    row.theUnit = this.replaceSL(row.theUnit, '');
                    if(row.theUnit.length > 5) {
                        row.validateInfo.theUnit = {
                            validateOk: false,
                            errorMsg: '[单位]单元长度最大5，当前[' + row.theUnit.length + ']'
                        };
                    }
                }
                // 检查 [预计使用年限]
                if(!Utils.isNoB(row.expectedLife) && !Utils.isNaturalStr(row.expectedLife, true)) {
                    row.validateInfo.expectedLife = {
                        validateOk: false,
                        errorMsg: '[预计使用年限]必须为大于0的整数'
                    };
                }
                //
                // 检查 [购买日期] 和 [收货日期] 必具其一，并且 [收货日期] >= [购买日期]
                let curDate = new Date().format('yyyy-MM-dd');
                if(row.buyDate == null && row.recvDate == null) {
                    row.validateInfo.recvDate = {
                        validateOk: false,
                        errorMsg: '[收货日期]单元 不能为空'
                    };
                } else if(row.buyDate != null) {
                    if(row.buyDate > curDate) {
                        row.validateInfo.buyDate = {
                            validateOk: false,
                            errorMsg: '[购买日期] 不能晚于今天'
                        };
                    }
                    if(row.recvDate != null && row.recvDate < row.buyDate) {
                        row.validateInfo.recvDate = {
                            validateOk: false,
                            errorMsg: '[收货日期] 不能早于 [购买日期]'
                        };
                    }
                } else if(row.recvDate > curDate) {
                    row.validateInfo.recvDate = {
                        validateOk: false,
                        errorMsg: '[收货日期]不能晚于今天'
                    };
                }
                if(row.receiptDate != null) {
                    if(row.receiptDate < curDate) {
                        row.validateInfo.receiptDate = {
                            validateOk: false,
                            errorMsg: '[验收日期] 不能晚于今天'
                        };
                    } else if(row.recvDate != null && row.receiptDate < row.recvDate) {
                        row.validateInfo.receiptDate = {
                            validateOk: false,
                            errorMsg: '[验收日期] 不能早于收货日期'
                        };
                    }
                }
                // 检查修正 [质保期]
                if(row.wrntPeriod != null) {
                    if(!Utils.isNaturalStr(row.wrntPeriod, true) || row.wrntPeriod <= 0) {
                        row.validateInfo.wrntPeriod = {
                            validateOk: false,
                            errorMsg: '[质保期(月)]单元为 > 0 的整数'
                        };
                    }
                }
                // 检查责任部门 检查责任人
                if(Utils.isNoB(row.departName) && Utils.isNoB(row.departNo)) {
                    if(!Utils.isNoB(row.principalName)) {
                        row.validateInfo.departName = {
                            validateOk: false,
                            errorMsg: '请先设置[责任部门]'
                        };
                        row.validateInfo.principalName = {
                            validateOk: false,
                            errorMsg: '请先设置[责任部门]'
                        };
                    }
                } else {
                    if(row.departId == null) {
                        row.validateInfo.departName = {
                            validateOk: false,
                            errorMsg: '[责任部门]单元对应的部门在本机构未找到'
                        };
                        row.validateInfo.principalName = {
                            validateOk: false,
                            errorMsg: '[责任部门]单元对应的部门在本机构未找到'
                        };
                    } else {
                        if((!Utils.isNoB(row.principalName) || !Utils.isNoB(row.principalNo)) && row.principalId == null) {
                            row.validateInfo.principalName = {
                                validateOk: false,
                                errorMsg: '[责任人]异常,请手动设置'
                            };
                        }
                    }
                }
                // 检查修正 [设备部件]
                let devcParts = row.devcParts;
                if(!Utils.isNoB(devcParts)) {
                    if(devcParts.length > 300) {
                        row.validateInfo.devcParts = {
                            validateOk: false,
                            errorMsg: '[设备部件]单元长度最大300，当前[' + devcParts.length + ']'
                        };
                    }
                    let devcPartList = devcParts.split('|') || [];
                    for(let i = 0; i < devcPartList.length; i++) {
                        let devcPart = devcPartList[i];
                        if(!Utils.isNoB(devcPart) && devcPart.length > 30) {
                            row.validateInfo.devcParts = {
                                validateOk: false,
                                errorMsg: '[设备部件]单元单个部件长度不能超过30'
                            };
                            if(Utils.isFalse(row.validateInfo.devcParts.validateOk)) {
                                break;
                            }
                        }
                    }
                }
                // 检查修正 [备注]
                if(!Utils.isNoB(row.memo)) {
                    if(row.memo.length > 60) {
                        row.validateInfo.memo = {
                            validateOk: false,
                            errorMsg: '[备注]单元长度最大60，当前[' + row.memo.length + ']'
                        };
                    }
                }
                // 检查修正 [备注]
                if(!Utils.isNoB(row.memo1)) {
                    if(row.memo1.length > 60) {
                        row.validateInfo.memo1 = {
                            validateOk: false,
                            errorMsg: '[备注1]单元长度最大60，当前[' + row.memo1.length + ']'
                        };
                    }
                }
                // 检查修正 [备注]
                if(!Utils.isNoB(row.memo2)) {
                    if(row.memo2.length > 60) {
                        row.validateInfo.memo2 = {
                            validateOk: false,
                            errorMsg: '[备注2]单元长度最大60，当前[' + row.memo2.length + ']'
                        };
                    }
                }
                // 检查修正 [备注]
                if(!Utils.isNoB(row.memo3)) {
                    if(row.memo3.length > 60) {
                        row.validateInfo.memo3 = {
                            validateOk: false,
                            errorMsg: '[备注3]单元长度最大60，当前[' + row.memo3.length + ']'
                        };
                    }
                }
                // 检查修正[归类标签]
                if(!Utils.isNoB(row.classifyTagName) && row.classifyTagId == null) {
                    row.validateInfo.classifyTagName = {
                        validateOk: false,
                        errorMsg: '[归类标签]在系统中未找到'
                    };
                }
                // 特种设备
                if(row.assetType == '批量式管理') {
                    orw.specialFlag = false;
                }
            }
            //记录被选中的行
            let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
            //
            this.shopDeviceImpItemList = rows;
            //（必须）延迟恢复被选中的行
            setTimeout(function () {
                self.shopDeviceImpItemList.forEach(function (row) {
                    if(oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                        self.$refs.deviceImpInfoTable.toggleRowSelection(row);
                    }
                });
            }, 1000);
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.handlePageChange(1);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.getShopDeviceImpItemPageListByFilter();
        },
        downloadDeviceImpModel: function () {
            let shopDeviceImpRec = this.shopDeviceImpRec;
            let dto = {};
            dto.originalFileName = shopDeviceImpRec.fileName;
            dto.deviceFlag = shopDeviceImpRec.deviceFlag;
            dto.filterItems = this.filterItems;
            devcApi.saveDeviceImpModelForExport(dto, function (result) {
                if(result.type == 'info') {
                    Utils.downloadFile(getAppUrl(result.data));
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 资产分类
        setDevcCat(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要设置的行');
                                return;
                            }
                            let params = {
                                checkBox: false,
                                filter: {
                                    relSysFlag: true,
                                    disabled: false,
                                    level: 3
                                }
                            };
                            showDevcCatSelectDlg(params, function (devcCat, theDlg) {
                                theDlg.close();
                                devcCat = devcCat || {};
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    let tmpRow = self.multipleSelection[i];
                                    let model = self.shopDeviceImpItemList.find(function (row) {
                                        return row.id == tmpRow.id;
                                    });
                                    model.innerDevcCatId = devcCat.id;
                                    model.innerDevcCatCode = devcCat.code;
                                    model.innerDevcCatName = devcCat.name;
                                }
                                self.checkData();
                            });
                        }
                    }
                }, '设置')
            ])
        },
        // 资产品牌
        setDevcBrand(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要设置的行');
                                return;
                            }
                            //
                            showDevcBrandSelectDlg({
                                checkBox: false,
                                filter: {
                                    relSysFlag: true,
                                    disabled: false
                                }
                            }, function (devcBrand, theDlg) {
                                theDlg.close();
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    let tmpRow = self.multipleSelection[i];
                                    let model = self.shopDeviceImpItemList.find(function (row) {
                                        return row.id == tmpRow.id;
                                    });
                                    model.innerDevcBrandId = devcBrand.id;
                                    model.innerDevcBrandCode = devcBrand.code;
                                    model.innerDevcBrandName = devcBrand.name;
                                    if(Utils.isNoB(model.brandId) && Utils.isNoB(model.brandName) && !Utils.isNoB(devcBrand.sysBrandId) && devcBrand.sysBrandId != -1) {
                                        model.brandName = devcBrand.sysBrandName;
                                        model.brandId = devcBrand.sysBrandId;
                                    }
                                }
                                self.checkData();
                            });
                        }
                    }
                }, '设置'),
            ])
        },
        // 设置维保分组
        setDevcGroup(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要设置的行');
                                return;
                            }
                            let params = {
                                filter: {
                                    level: 2
                                },
                                checkBox: false
                            };
                            showDevcGroupSelectDlg(params, function (devcGroup, theDlg) {
                                theDlg.close();
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    let tmpRow = self.multipleSelection[i];
                                    let model = self.shopDeviceImpItemList.find(function (row) {
                                        return row.id == tmpRow.id;
                                    });
                                    model.devcGroupId = devcGroup.id;
                                    model.devcGroupId1 = devcGroup.parentId;
                                    model.devcGroupId2 = devcGroup.id;
                                    model.devcGroupName = devcGroup.name;
                                    model.devcGroupFullName = devcGroup.fullName;
                                }
                                self.checkData();
                            });
                        }
                    }
                }, '设置'),
            ])
        },
        setInitStartDate(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            self.setDate('initStartDate');
                        }
                    }
                }, '设置'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            //弹出确认框
                            self.$confirm('确认要清除所选行的启用日期?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                for(var i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].initStartDate = null;
                                }
                                self.checkData();
                            }).catch(function () {
                            });
                        }
                    }
                }, '清除')
            ])
        }
        ,
        setBuyDate(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            self.setDate('buyDate');
                        }
                    }
                }, '设置'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            //弹出确认框
                            self.$confirm('确认要清除所选行的购买日期?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].buyDate = null;
                                }
                                self.checkData();
                            }).catch(function () {
                            });
                        }
                    }
                }, '清除')
            ])
        },
        setRecvDate(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            self.setDate('recvDate');
                        }
                    }
                }, '设置'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            //弹出确认框
                            self.$confirm('确认要清除所选行的收货日期?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].recvDate = null;
                                }
                                self.checkData();
                            }).catch(function () {
                            });
                        }
                    }
                }, '清除')
            ])
        },
        setReceiptDate(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            self.setDate('receiptDate');
                        }
                    }
                }, '设置'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            //弹出确认框
                            self.$confirm('确认要清除所选行的验收日期?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].receiptDate = null;
                                }
                                self.checkData();
                            }).catch(function () {
                            });
                        }
                    }
                }, '清除')
            ])
        },
        setBuyDate(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            self.setDate('buyDate');
                        }
                    }
                }, '设置'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            //弹出确认框
                            self.$confirm('确认要清除所选行的购置日期?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].buyDate = null;
                                }
                                self.checkData();
                            }).catch(function () {
                            });
                        }
                    }
                }, '清除')
            ])
        },
        setDate(type, formatType, filed) {
            let self = this;
            if(self.multipleSelection.length == 0) {
                self.$message.warning('请勾选要设置的行');
                return;
            }
            let theDlg = Vue.$showDialog({
                title: '选择日期',
                width: 300,
                height: 200,
                showCloseBtn: true,
                template: '<div>' +
                    '<swb-shop-device-imp-set-date :formatType="formatType" ref="swb_shop_device_imp_set_date"></swb-shop-device-imp-set-date>' +
                    '</div>',
                data: {
                    formatType: formatType
                },
                okClicked: function () {
                    let result = this.$refs.swb_shop_device_imp_set_date.getDlgResult() || {};
                    if(result.type == 'info') {
                        let selectDate = result.data;
                        for(let i = 0; i < self.multipleSelection.length; i++) {
                            if(type == 'custFiled') {
                                self.multipleSelection[i][type][filed] = selectDate;
                            } else {
                                self.multipleSelection[i][type] = selectDate;
                            }
                        }
                        self.checkData();
                        return true;
                    } else {
                        self.$message.warning(result.message);
                    }
                    return false;
                },
                methods: {}
            });
        },
        setBrand(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要设置的行');
                                return;
                            }
                            let catId = null;
                            for(var i = 0; i < self.multipleSelection.length; i++) {
                                var obj = self.multipleSelection[i];
                                if(obj.catId == null) {
                                    MsgBox.warning('请选择已设置商品分类的行');
                                    return;
                                }
                                if(catId == null) {
                                    catId = obj.catId;
                                } else if(catId != obj.catId) {
                                    MsgBox.warning('请选择相同商品分类的行');
                                    return;
                                }
                            }
                            let params = {
                                selectIds: [],
                                catId: catId
                            };
                            openBrandListSelectDlg(false, params, function (brand) {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].brandName = brand.dispName;
                                    self.multipleSelection[i].brandId = brand.id;
                                }
                                self.checkData();
                            });
                        }
                    }
                }, '设置'),
            ])
        },
        setDepart(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要设置的行');
                                return;
                            }
                            Vue.$showDialog({
                                title: '责任部门 - 选择',
                                width: 750,
                                height: 600,
                                showCloseBtn: true,
                                template: '<swb-org-tree  :bizUnitId="bizUnitId" :comFlag="true" :isRadio="true" :bizDepart="true"  ref="swb_org_tree"></swb-org-tree>',
                                data: {
                                    bizUnitId: self.shopDeviceImpRec.shopBizUnitId
                                },
                                okClicked: function () {
                                    let result = this.$refs.swb_org_tree.getDlgResult() || {};
                                    if(result.type == 'info') {
                                        let selectComInfo = result.data;
                                        for(let i = 0; i < self.multipleSelection.length; i++) {
                                            self.multipleSelection[i].departId = selectComInfo.id;
                                            self.multipleSelection[i].departName = selectComInfo.name;
                                            self.multipleSelection[i].departNo = selectComInfo.no;
                                        }
                                        self.checkData();
                                    } else {
                                        return false;
                                    }
                                }
                            });
                        }
                    }
                }, '设置'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            //弹出确认框
                            self.$confirm('确认要清除所选行的责任部门?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].departId = null;
                                    self.multipleSelection[i].departName = null;
                                    self.multipleSelection[i].departNo = null;
                                    self.multipleSelection[i].principalId = null;
                                    self.multipleSelection[i].principalName = null;
                                    self.multipleSelection[i].principalNo = null;
                                }
                                self.checkData();
                            }).catch(function () {
                            });
                        }
                    }
                }, '清除')
            ])
        },
        setBathPrincipal(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要设置的行');
                                return;
                            }
                            let departIds = self.multipleSelection.pluck('departId');
                            let departIdList = [];
                            departIds.forEach(function (departId) {
                                if(!departIdList.contains(departId)) {
                                    departIdList.push(departId);
                                }
                            });
                            if(departIdList.length > 1) {
                                MsgBox.warning('请选择相同的责任部门进行批量设置责任人');
                                return;
                            }
                            let departId = departIdList[0];
                            if(Utils.isNoB(departId)) {
                                MsgBox.warning('必须选择已设置责任部门的行进行设置责任人');
                                return;
                            }
                            openComStaffComnSelectDlg(departId, false, function (resultData, theDlg) {
                                theDlg.close();
                                let departStaff = resultData.data || {};
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].principalId = departStaff.id;
                                    self.multipleSelection[i].principalName = departStaff.name;
                                    self.multipleSelection[i].principalNo = departStaff.no;
                                }
                                self.checkData();
                            });
                        }
                    }
                }, '设置'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            //弹出确认框
                            self.$confirm('确认要清除所选行的责任人?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].principalId = null;
                                    self.multipleSelection[i].principalName = null;
                                    self.multipleSelection[i].principalNo = null;
                                }
                                self.checkData();
                            }).catch(function () {
                            });
                        }
                    }
                }, '清除')
            ])
        },
        setPrincipal(row) {
            let self = this;
            if(Utils.isNoB(row.departId)) {
                MsgBox.warning('请先设置责任部门');
            } else {
                openComStaffComnSelectDlg(row.departId, false, function (resultData, theDlg) {
                    theDlg.close();
                    let departStaff = resultData.data || {};
                    for(let i = 0; i < self.multipleSelection.length; i++) {
                        self.multipleSelection[i].principalId = departStaff.id;
                        self.multipleSelection[i].principalName = departStaff.name;
                        self.multipleSelection[i].principalNo = departStaff.no;
                    }
                    self.checkData();
                });
            }
        },
        delPrincipal(row) {
            row.principalId = null;
            row.principalName = null;
            row.principalNo = null;
            this.checkData();
        },
        autoSetBatchNo(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            let rows = self.shopDeviceImpItemList.clone();
                            for(let i = 0; i < rows.length; i++) {
                                let row = rows[i];
                                if(Utils.isNoB(row.batchNo)) {
                                    let batchNoDate = new Date();
                                    if(!Utils.isNoB(row.buyDate)) {
                                        batchNoDate = row.buyDate;
                                    } else if(!Utils.isNoB(row.recvDate)) {
                                        batchNoDate = row.recvDate;
                                    }
                                    //
                                    row.batchNo = new Date(batchNoDate).format('yyyyMMdd');
                                }
                            }
                            self.checkData();
                        }
                    }
                }, '自动生成批次号'),
            ])
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        replaceSL(str, char) {
            if(!Utils.isNoB(str)) {
                str = Utils.replace(str, '\r\n', char);
                str = Utils.replace(str, '\r', char);
                str = Utils.replace(str, '\n', char);
            }
            return str;
        },
        setBathDevcDef(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要设置的行');
                                return;
                            }
                            //
                            let durableCount = 0;
                            let singleCount = 0;
                            for(let i = 0; i < self.multipleSelection.length; i++) {
                                let item = self.multipleSelection[i];
                                if(Utils.isTrue(item.assetType == 1)) {
                                    durableCount += 1;
                                } else {
                                    singleCount += 1;
                                }
                            }
                            if(durableCount > 0 && singleCount > 0) {
                                self.$message.warning('勾选的行必须都是批量的或者都是单品的');
                                return;
                            }
                            let params = {};
                            if(durableCount > 0) {
                                params.assetType = 1;
                            } else {
                                params.assetType = 0;
                            }
                            showMerchtDevcDefSelectDlg(params, function (devcDef, dlg) {
                                dlg.close();
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].devcDefId = devcDef.id;
                                    self.multipleSelection[i].devcDefCode = devcDef.innerCode;
                                    self.multipleSelection[i].srcData = Utils.merge({}, self.multipleSelection[i]);
                                    self.multipleSelection[i].brandId = devcDef.brandId;
                                    self.multipleSelection[i].brandName = devcDef.brandName;
                                    self.multipleSelection[i].devcName = devcDef.name;
                                    // self.multipleSelection[i].title = devcDef.title;
                                    self.multipleSelection[i].theUnit = devcDef.theUnit;
                                    self.multipleSelection[i].model = devcDef.model;
                                    self.multipleSelection[i].fixedSpec = devcDef.fixedSpec;
                                    self.multipleSelection[i].fixedSpecCode = devcDef.innerCode;
                                    //
                                    if(Utils.isNoB(self.multipleSelection[i].title)) {
                                        self.multipleSelection[i].title = devcDef.title;
                                    }
                                    if(Utils.isNoB(self.multipleSelection[i].innerDevcCatCode) && Utils.isNoB(self.multipleSelection[i].innerDevcCatName)) {
                                        self.multipleSelection[i].innerDevcCatId = devcDef.innerDevcCatId;
                                        self.multipleSelection[i].innerDevcCatCode = devcDef.innerDevcCode;
                                        self.multipleSelection[i].innerDevcCatName = devcDef.innerDevcCatName;
                                    }
                                    if(Utils.isNoB(self.multipleSelection[i].innerDevcBrandCode) && Utils.isNoB(self.multipleSelection[i].innerDevcBrandName)) {
                                        self.multipleSelection[i].innerDevcBrandId = devcDef.innerDevcBrandId;
                                        self.multipleSelection[i].innerDevcBrandCode = devcDef.innerDevcBrandCode;
                                        self.multipleSelection[i].innerDevcBrandName = devcDef.innerDevcBrandName;
                                    }
                                    if(Utils.isNoB(self.multipleSelection[i].assetKindCode)) {
                                        self.multipleSelection[i].assetKindCode = devcDef.assetKindCode;
                                        self.multipleSelection[i].assetKindName = devcDef.assetKindName;
                                    }
                                    if(Utils.isNoB(self.multipleSelection[i].durableLife)) {
                                        self.multipleSelection[i].durableLife = devcDef.durableLife;
                                    }
                                }
                                self.checkData();
                            });
                        }
                    }
                }, '选择'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            //弹出确认框
                            self.$confirm('确认要清除所选行的关联定义吗?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    if(self.multipleSelection[i].devcDefId != null && self.multipleSelection[i].devcDefId != -1) {
                                        self.multipleSelection[i].devcDefId = null;
                                        self.multipleSelection[i].devcDefCode = null;
                                        if(!Utils.isNoB(self.multipleSelection[i].srcData)) {
                                            self.multipleSelection[i].brandId = self.multipleSelection[i].srcData.brandId;
                                            self.multipleSelection[i].brandName = self.multipleSelection[i].srcData.brandName;
                                            self.multipleSelection[i].devcName = self.multipleSelection[i].srcData.devcName;
                                            self.multipleSelection[i].title = self.multipleSelection[i].srcData.title;
                                            self.multipleSelection[i].theUnit = self.multipleSelection[i].srcData.theUnit;
                                            self.multipleSelection[i].model = self.multipleSelection[i].srcData.model;
                                            self.multipleSelection[i].fixedSpec = self.multipleSelection[i].srcData.fixedSpec;
                                            self.multipleSelection[i].fixedSpecCode = self.multipleSelection[i].srcData.fixedSpecCode;
                                            self.multipleSelection[i].durableLife = self.multipleSelection[i].srcData.durableLife;
                                            self.multipleSelection[i].expectedLife = self.multipleSelection[i].srcData.expectedLife;
                                            self.multipleSelection[i].innerDevcCatId = self.multipleSelection[i].srcData.innerDevcCatId;
                                            self.multipleSelection[i].innerDevcCatCode = self.multipleSelection[i].srcData.innerDevcCatCode;
                                            self.multipleSelection[i].innerDevcCatName = self.multipleSelection[i].srcData.innerDevcCatName;
                                            self.multipleSelection[i].innerDevcBrandId = self.multipleSelection[i].srcData.innerDevcBrandId;
                                            self.multipleSelection[i].innerDevcBrandCode = self.multipleSelection[i].srcData.innerDevcBrandCode;
                                            self.multipleSelection[i].innerDevcBrandName = self.multipleSelection[i].srcData.innerDevcBrandName;
                                            self.multipleSelection[i].assetKindCode = self.multipleSelection[i].srcData.assetKindCode;
                                            self.multipleSelection[i].assetKindName = self.multipleSelection[i].srcData.assetKindName;
                                            self.multipleSelection[i].srcData = null;
                                        }
                                    }
                                }
                                self.checkData();
                            }).catch(function () {
                            });
                        }
                    }
                }, '清除')
            ])
        },
        setDevcDef(row) {
            let self = this;
            let assetType = null;
            if(Utils.isTrue(row.assetType == '批量式管理')) {
                assetType = 1;
            } else {
                assetType = 0;
            }
            let modelSpec = row.model + '' + row.fixedSpec;
            showMerchtDevcDefSelectDlg({
                catId: row.catId,
                brandId: row.brandId,
                modelSpec: modelSpec,
                assetType: assetType
            }, function (devcDef, dlg) {
                dlg.close();
                row.devcDefId = devcDef.id;
                row.devcDefCode = devcDef.innerCode;
                row.srcData = Utils.merge({}, row);
                row.brandId = devcDef.brandId;
                row.brandName = devcDef.brandName;
                row.devcName = devcDef.name;
                row.theUnit = devcDef.theUnit;
                row.model = devcDef.model;
                row.fixedSpec = devcDef.fixedSpec;
                row.fixedSpecCode = devcDef.innerCode;
                if(Utils.isNoB(row.devcTitle)) {
                    row.devcTitle = devcDef.title;
                }
                if(Utils.isNoB(row.innerDevcCatCode) && Utils.isNoB(row.innerDevcCatName)) {
                    row.innerDevcCatId = devcDef.innerDevcCatId;
                    row.innerDevcCatCode = devcDef.innerDevcCode;
                    row.innerDevcCatName = devcDef.innerDevcCatName;
                }
                if(Utils.isNoB(row.innerDevcBrandCode) && Utils.isNoB(row.innerDevcBrandName)) {
                    row.innerDevcBrandId = devcDef.innerDevcBrandId;
                    row.innerDevcBrandCode = devcDef.innerDevcBrandCode;
                    row.innerDevcBrandName = devcDef.innerDevcBrandName;
                }
                if(Utils.isNoB(row.assetKindCode)) {
                    row.assetKindCode = devcDef.assetKindCode;
                    row.assetKindName = devcDef.assetKindName;
                }
                self.checkData();
            });
        },
        showDevcDef(id) {
            openDevcDefDetailDlg(id);
        },
        setClassifyTag(h) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要设置的行');
                                return;
                            }
                            showDevcClassifyTagListSelectDlg(function (tag) {
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    self.multipleSelection[i].classifyTagId = tag.id;
                                    self.multipleSelection[i].classifyTagName = tag.name;
                                }
                                self.checkData();
                            });
                        }
                    }
                }, '选择'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            for(let i = 0; i < self.multipleSelection.length; i++) {
                                self.multipleSelection[i].classifyTagId = null;
                                self.multipleSelection[i].classifyTagName = null;
                            }
                            self.checkData();
                        }
                    }
                }, '清除')
            ])
        },
        setCustField(h, field) {
            let self = this;
            return h('span', [
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            self.setDate('custFiled', 'yyyy-MM-dd', field);
                        }
                    }
                }, '设置'),
                h('a', {
                    class: 'swb-btn swb-btn-link',
                    on: {
                        click: function () {
                            if(self.multipleSelection.length == 0) {
                                self.$message.warning('请勾选要清除的行');
                                return;
                            }
                            for(let i = 0; i < self.multipleSelection.length; i++) {
                                self.multipleSelection[i]['custFiled'][field] = null;
                            }
                            self.checkData();
                        }
                    }
                }, '清除')
            ])
        },
        getShopDeviceImpRecById: function (recId) {
            let self = this;
            devcApi.getShopDeviceImpRecById(recId, function (result) {
                if(result.type == 'info') {
                    let shopDeviceImpRec = result.data;
                    if(!Utils.isNoB(shopDeviceImpRec.tplConfig)) {
                        let custFiledMap = JSON.decode(shopDeviceImpRec.tplConfig);
                        self.custFileds = custFiledMap['店铺资产列表'];
                    }
                    self.shopDeviceImpRec = shopDeviceImpRec;
                    self.tplUsage = shopDeviceImpRec.tplUsage;
                    self.getComnXportConfByUsage(shopDeviceImpRec.tplUsage);
                    self.getShopDeviceImpItemPageListByFilter();
                } else {
                    self.$message.warning(result.message);
                }
            });
        },
        queryHandler(queryModel) {
            this.queryModel = queryModel;
            this.getShopDeviceImpItemPageListByFilter();
        },
        getShopDeviceImpItemPageListByFilter() {
            let self = this;
            self.showTable = false;
            let shopDeviceImpRec = this.shopDeviceImpRec;
            //
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            filterItems.recId = shopDeviceImpRec.id;
            filterItems.execStates = [0, -1];
            //
            self.filterItems = filterItems;
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            devcApi.getShopDeviceImpItemPageListByFilter(postData, function (result) {
                if(result.type == 'info') {
                    let shopDeviceImpItemList = result.data.rows;
                    shopDeviceImpItemList.forEach(function (el) {
                        let custFiled = {};
                        if(el.custJson != null && el.custJson != '') {
                            custFiled = JSON.decode(el.custJson);
                        }
                        el.custFiled = custFiled;
                    });
                    self.shopDeviceImpItemList = shopDeviceImpItemList;
                    self.totalCount = result.data.pagination.totalCount;
                    self.checkData();
                } else {
                    self.$message.warning(result.message);
                }
                self.showTable = true;
            });
        },
        saveImpItemList() {
            let shopDeviceImpItemList = Utils.merge([], this.shopDeviceImpItemList);
            let warnMsg = null;
            for(let i = 0; i < shopDeviceImpItemList.length; i++) {
                let deviceImpInfo = shopDeviceImpItemList[i];
                if(Utils.isNoB(deviceImpInfo.devcDefId) || deviceImpInfo.devcDefId == -1) {
                    warnMsg = '请设置定义信息';
                    break;
                }
                //
                deviceImpInfo.checkState = 0;
                deviceImpInfo.checkFailMsg = '';
                deviceImpInfo.execState = 0;
                deviceImpInfo.execFailMsg = '';
            }
            if(!Utils.isNoB(warnMsg)) {
                MsgBox.warning(warnMsg);
                return;
            }
            let self = this;
            devcApi.updateDeviceImpItemListModel(shopDeviceImpItemList, function (result) {
                if(result.type == 'info') {
                    self.getShopDeviceImpItemPageListByFilter();
                    self.refreshFlag = true;
                    Toast.show('保存成功');
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        deviceImpIn() {
            let self = this;
            let shopDeviceImpRec = this.shopDeviceImpRec;
            let uploadParams = {
                title: '设备导入',
                fileFor: 'devc.import',
                fileGroup: 'device.import',
                multipleFile: false,
                custFileds: JSON.encode(self.devcCustFieldList),
                lableText: '更新导入',
                downloadText: '导出数据',
                usage: shopDeviceImpRec.tplUsage
            };
            fileUploadGroupShowDlg(uploadParams, null, function (result, theDlg) {
                // theDlg 关闭弹框
                theDlg.close();
                if(result.type === 'info') {
                    let files = result.data.files;
                    self.file = files[0];
                    // 文件是否按模版导入
                    let errorMsgList = self.file.extra.errorMsgList;
                    if(!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                        MsgBox.warning(errorMsgList.join('<br/>'));
                        return;
                    }
                    self.handleImpInfoStart(self.file.extra);
                } else {
                    MsgBox.warning(result.message);
                }
            }, function () {
                self.downloadDeviceImpModel();
            });
        },
        handleImpInfoStart(extra) {
            let self = this;
            let shopDeviceImpRec = this.shopDeviceImpRec;
            let deviceImpDto = {
                importRecId: shopDeviceImpRec.id,
            };
            this.startDone(deviceImpDto, extra.deviceImpInfoList, 1, 5000);
        },
        startDone(srcImpDto, srcImpInfoList, pageNumber, pageSize) {
            let self = this;
            let paramImpDto = Utils.merge({}, srcImpDto);
            let totalCount = srcImpInfoList.length;
            let start = (pageNumber - 1) * pageSize;
            let end = pageNumber * pageSize;
            let paramImpInfoList = srcImpInfoList.slice(start, end);
            paramImpDto.deviceImpInfoList = paramImpInfoList;
            paramImpDto.lastFlag = end >= totalCount;
            // end/totalCount
            let theLoading = MsgBox.loading('正在处理【' + end + '/' + totalCount + '】，请稍后...');
            devcApi.saveDeviceImpModel(paramImpDto, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    srcImpDto.importRecId = result.data;
                } else if(paramImpDto.importRecId == null) {
                    // 第一此都没过去，记录没生成,直接结束
                    MsgBox.warning(result.message);
                    return;
                }
                if(end < totalCount) {
                    pageNumber = pageNumber + 1;
                    self.startDone(srcImpDto, srcImpInfoList, pageNumber, pageSize);
                } else {
                    // 最后一批结束
                    self.getShopDeviceImpItemPageListByFilter();
                    self.$message.success('文件数据保存成功,请检查通过后执行导入');
                }
                self.refreshFlag = true;
            });
        },
        getDlgResult: function () {
            return this.refreshFlag;
        }
    }
}
</script>

<style>
.el-table .selected-row {
    background: #c9e5f5;
}
</style>



// WEBPACK FOOTER //
// src/compo/devc/ShopDevcImpDevcCheck.vue